import React, {PureComponent} from 'react';
import {Field, reduxForm} from 'redux-form';
import MailRuIcon from 'mdi-react/MailRuIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import {Link} from 'react-router-dom';
import * as TextManager from '../../../modules/languages/TextManager';
import * as http from '../../../modules/http';
import {fetchUserDataIfNeeded} from '../../../redux/actions/UserActions';
//import {fetchUtilsDataIfNeeded} from '../../../redux/actions/UtilsActions';
import Alert from '../../../components/Alert';
import LoadingProgress from '../../../components/LoadingProgress'
import CheckBox from './CheckBox'
import {Col, Row} from 'reactstrap';

class LogInForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
            loading: false,
            error: false,
            loginFailed: false,
            loginID: 0,
            forgotPasswordData: false,
            forgotPasswordSuccess: false,
            forgotPasswordError: false,
        };

        this.data = {username: '', password: '', rememberMe: false};

        this.showPassword = this.showPassword.bind(this);
    }

    showPassword(e) {
        e.preventDefault();
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    changeEmail(userName) {
        this.data.username = userName;
    }

    changePassword(password) {
        this.data.password = password;
    }

    setRememberMe(rememberMe) {
        this.data.rememberMe = rememberMe;
    }

    forgotPassword(e) {

        if (this.data.username === '') {
            this.setState({forgotPasswordData: true});
            return;
        }
        http.postToServer('request_send_password',
            this.data,
            () => this.setState({forgotPasswordSuccess: true, forgotPasswordData: false, forgotPasswordError: false}),
            () => this.setState({forgotPasswordSuccess: false, forgotPasswordData: false, forgotPasswordError: true}),
            () => this.setState({forgotPasswordSuccess: false, forgotPasswordData: false, forgotPasswordError: true})
        );
    }

    login(event) {

        event.preventDefault();

        localStorage.setItem('isImpersonate', 'false');
        localStorage.setItem('impersonatedAffiliate', "");

        this.setState({loading: true});
        var loginID = Math.random();

        http.postToServer('login',
            this.data,
            (data) => {
                this.setState({loginFailed: false, error: false, loading: false, loginID: loginID});
                this.props.dispatch(fetchUserDataIfNeeded(true));
                //this.props.dispatch(fetchUtilsDataIfNeeded(true));
            },
            () => this.setState({error: true, loginFailed: false, loading: false, loginID: loginID}),
            () => this.setState({loginFailed: true, error: false, loading: false, loginID: loginID})
        );
    }

    render() {


        return (
            <form className='form' onSubmit={(event) => this.login(event)}>

                {this.state.loginFailed &&
                <Alert messageID={this.state.loginID} color='warning' className='alert--neutral' icon>
                    <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span></p>
                    <p>{TextManager.getCurrentTextResource().Text.invalidUserPassword}</p>
                </Alert>
                }

                {this.state.error &&
                <Alert messageID={this.state.loginID} color='danger' className='alert--neutral' icon>
                    <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                    <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                </Alert>
                }

                {this.state.forgotPasswordData &&
                <Alert messageID={this.state.loginID} color='danger' className='alert--neutral' icon>
                    <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.pleaseProvideEmail}</span></p>
                </Alert>
                }

                {this.state.forgotPasswordSuccess &&
                <Alert messageID={this.state.loginID} color='success' className='alert--neutral' icon>
                    <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.emailHasBeenSent}</span></p>
                </Alert>
                }

                {this.state.forgotPasswordError &&
                <Alert messageID={this.state.loginID} color='danger' className='alert--neutral' icon>
                    <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                </Alert>
                }

                <div className='form__form-group'>
                    <label className='form__form-group-label'>{TextManager.getCurrentTextResource().Text.name}</label>
                    <div className='form__form-group-field'>
                        <div className='form__form-group-icon'>
                            <MailRuIcon/>
                        </div>
                        <input
                            name='email'
                            onChange={(event) => this.changeEmail(event.target.value)}
                            component='input'
                            type='text'
                            placeholder='example@mail.com'
                        />
                    </div>
                </div>
                <div className='form__form-group'>
                    <label
                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Text.password}</label>
                    <div className='form__form-group-field'>
                        <div className='form__form-group-icon'>
                            <KeyVariantIcon/>
                        </div>
                        <input
                            name='password'
                            onChange={(event) => this.changePassword(event.target.value)}
                            component='input'
                            type={this.state.showPassword ? 'text' : 'password'}
                            placeholder={TextManager.getCurrentTextResource().Text.password}
                        />
                    </div>
                    <div className='account__forgot-password'>
                    </div>
                </div>
                <div className='form__form-group'>
                    <div className='form__form-group-field'>
                    </div>
                </div>

                {!this.state.loading ?
                    <div className='form__form-group'>
                        <Row>
                        <Col md={12} sm={12} xs={12} lg={12}>
                            <button type='submit'
                                    className='btn btn-primary account__btn account__btn'>{TextManager.getCurrentTextResource().Text.signIn}</button>
                        </Col>
                            <span style={{display: "inline-block", height: 60}}></span>
                        </Row>
                    </div> : <span></span>
                }

                {this.state.loading &&
                <LoadingProgress/>
                }

            </form>
        )
    }
}

export default reduxForm({
    form: 'log_in_form', // a unique identifier for this form
})(LogInForm);
